'use client';

import type {
  SearchReverseProposalGoodsServiceRequest,
  SearchReverseProposalGoodsServiceResponse,
} from '@musinsa/services-curator';
import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useReverseProposalGoods = (
  params: Omit<SearchReverseProposalGoodsServiceRequest, 'page'>,
) => {
  return useInfiniteQuery({
    ...curatorQueries.campaigns.reverseProposalGoods(params),
    initialPageParam: 1,
    getNextPageParam: (lastPage: SearchReverseProposalGoodsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
  });
};

export const useReverseProposalGoodsDetail = (goodsNo: number | undefined) => {
  return useQuery({
    ...curatorQueries.campaigns.reverseProposalGoodsDetail({ goodsNo: goodsNo! }),
    enabled: goodsNo !== undefined,
  });
};
